import getPath from 'lodash/get'

const HIDE_CLASS = 'bx24-hidden'

type BX24ButtonType = {
  show: () => void
  hide: () => void
}

function getButtonInstance(): BX24ButtonType | null {
  return getPath(window, 'bx24.buttonInstance', null)
}

export function hideButton() {
  if (typeof window !== 'undefined') {
    document.body.classList.add(HIDE_CLASS)
    const buttonInstance = getButtonInstance()
    if (buttonInstance) {
      buttonInstance.hide()
    }
  }
}

export function showButton() {
  if (typeof window !== 'undefined') {
    document.body.classList.remove(HIDE_CLASS)
    const buttonInstance = getButtonInstance()

    if (buttonInstance) {
      buttonInstance.show()
    }
  }
}
